import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {PatchAdherenceDigitalPayment, PatchAdherenceDigitalPaymentParams} from 'domain/usecases';

export class RemotePatchAdherenceDigitalPayment implements PatchAdherenceDigitalPayment {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<void>,
	) {}

	async patch({adherencePaymentDate}: PatchAdherenceDigitalPaymentParams): Promise<void> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'patch',
			body: {
				adherencePaymentDate,
			},
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
			case HttpStatusCode.created:
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
